export const getProjetHref = (idProjet) => {
    return `/projet/${idProjet}`;
}